
const universeHelper = {
    
    securityValidate : (maxLimit, tableLength) => {
        
        let value = maxLimit * tableLength;
        
        if(value >= 100 ){
            return true;
        }
        else {
            return false
        }
    }
}

export default universeHelper;


// WEBPACK FOOTER //
// ./src/components/pages/Create/universe/universeHelper.js